import { AuthContext, IUser } from "@sagecentral/core-ui";
import { GridMetaData } from "models/grids";
import { useContext, useEffect, useState } from "react";

export interface IPorblemLogEntry {
    date: string,
    problem: string,
    resolved: boolean,
    task: string,
    taskId: number,
    workItem: string,
    workItemId: number,
    workflow: string,
    workflowId: number,
    id: number
}

type GetProjectProblemLogResult = {
    projectTasks: IPorblemLogEntry[],
    totalItems: number,
    hasViewPermission: boolean;
}

type ProjectTasksResult = [
    GetProjectProblemLogResult | null,
    boolean,
    string | null
];

export const useProjectProblemLog = ({ projectId, gridMetaData }: { projectId: number, gridMetaData: GridMetaData }): ProjectTasksResult => {
    const [result, setResult] = useState<GetProjectProblemLogResult | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const auth = useContext(AuthContext);

    useEffect(() => {
        if (projectId === 0) return;

        const controller = new AbortController();
        (async () => {
            const user = await auth.getUser() as IUser;
            if (user && user.id_token) {
                setLoading(true);
                try {
                    const headers = {
                        'Authorization': `Bearer ${user.id_token}`,
                        'Content-Type': 'application/json'
                    };

                    const sortByString = gridMetaData.sort?.map(s => `${s.field} ${s.dir}`).join();

                    const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3/projects/${projectId}/problemlog?pagesize=${gridMetaData.pageSize}&page=${gridMetaData.page+1}&orderBy=${sortByString}`, {
                        method: 'GET',
                        headers,
                        mode: 'cors',
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const response = await resp.json() as { data: IPorblemLogEntry[], count: number, hasViewProblemLogPrivileges: boolean };

                    setResult({
                        projectTasks: response.data,
                        totalItems: response.count,
                        hasViewPermission: response.hasViewProblemLogPrivileges
                    } as GetProjectProblemLogResult);
                    //setResult({} as GetProjectProblemLogResult);
                } catch (err) {

                } finally {
                    setLoading(false);
                }
            } else {
                // NOT LOGGED IN
                setError('Not logged in');
            }
        })().finally(() => {
            return () => {
                controller.abort();
            };
        });
    }, [projectId, gridMetaData.page, gridMetaData.pageSize, gridMetaData.sort]);

    return [
        result,
        loading,
        error
    ];
};

//export { useProjectProblemLog };